/* eslint-disable camelcase */
/* LIBS */
import React, {
    useCallback, useEffect, useMemo, useState,
} from 'react';
import {
    useQuery, useLazyQuery,
    useMutation, useReactiveVar,
    gql,
} from '@apollo/client';
import {
    selectedPeriodVar, isBasketFilledVar,
    promocodeVar, subscriptionTypeVar,
    paymentMethodVar,
} from 'app/apollo/reaction';
import queryString from 'query-string';

/* QUERIES AND MUTATIONS */
import {
    ADD_ITEMS_TO_CART_BY_ID_LIST,
    ADD_ITEMS_TO_CART_BY_SCHEMA,
} from 'app/graphql/network/basket/basketMutations';
import USER_QUERY from 'app/graphql/network/auth/userQuery.graphql';
import BILLING_MUTATION from 'app/graphql/network/billing';

/* SERVICES */
import { errorService } from 'global/services';

/* HOOKS AND UTILS */
import { useRouterState } from 'app/hooks/useRouterState';
import {
    parseCategories, parseDishes,
    parseMenuType, parseTags,
} from 'app/utils/basketSchema';
import { getDishesFromBasketSections } from 'app/utils/dish';
import {
    getTrialScenarioFromUrl, SCENARIO_3X2, SCENARIO_5X2,
} from 'app/utils/trial-scenario';

/* SERVICES */

/* HOOKS */
import {
    getInitilaPaymentMethod,
    // getInitilaSubsctiptionType
} from 'app/const/subscription';
import { URLUpdater } from 'global/utils';
import { MenuSkeletonPage } from 'app/components/Skeletons/MenuPageSkeletons';
import { useSpecificPeriodData } from 'app/hooks/accessors';
import {
    getPreAssembledType,
    usePreAssembledBasketType,
} from './contexts/filters.context/usePreAssembledBasketType';


// import { defineSubscriptionType, getBillingParams, trackBasketFilling } from './utils/basket';
import { removeFromHideParam } from './contexts/filters.context/filters.context';


export const BasketResolverContext = React.createContext(null);

const ROOT_BASKET_QUERY_COPY_RESOLVER = gql`
    query ROOT_BASKET_QUERY_COPY(
    $period: String!
) {
    selectedPeriod @client @export(as: "period")

    cart(
        period: $period
    ) {
        period
        isSubscriptionActivated
        haveDishesFromTrial
        id
        typeOfSet
        isSectionsEmpty @client
        type
        sections {
            id
            title
            gift_category
            cartType
            items {
                ...ROOT_CART_DISH_ITEM
                dish {
                    ...ROOT_MENU_DISH_ITEM
                }
            }
        }
        totals {
            ...ROOT_CART_TOTAL
        }
        discount_conditions {
            ...ROOT_CART_DISCOUNT_CONDITIONS
        }
    }
}`;

const ROOT_BILLING_MUTATION = gql`
    mutation ROOT_BILLING_MUTATION(
        $promocode: String,
        $period: String!,
        $payment_method: paymentMethod,
        $phone: String,
    ) {
        billing(
            promocode: $promocode,
            period: $period,
            payment_method: $payment_method,
            phone: $phone,
        ) {
            promocode
            payment_method
            isNewbie
        }
    }
`;


/**
 * type: singlePay || subscription
 * method: online || sbp
 */

export const getPaymentMethodAndType = (data) => {
    if (data === 'sbp') {
        return {
            type: 'singlePay',
            method: 'sbp',
        };
    }

    if (data === 'online') {
        return {
            type: 'singlePay',
            method: 'online',
        };
    }

    return {
        type: 'subscription',
        method: 'online',
    };
};

export const billingVarByMethodAndType = (type, method) => {
    if (`${type}:${method}` === 'singlePay:online' || method === 'online') {
        return 'online';
    }

    if (`${type}:${method}` === 'singlePay:sbp') {
        return 'sbp';
    }

    return 'recurrent';
};

/**
 * @description то что нужно обязательно выполнить после любой мутации billing
 */
export const onCompletedBillingMutation = ({ billing }) => {
    try {
        promocodeVar(billing?.promocode || '');

        const { type, method } = getPaymentMethodAndType(billing?.payment_method);

        paymentMethodVar(method);
        subscriptionTypeVar(type);

        URLUpdater({
            promo_code: billing?.promocode || '',
            payment: billing.payment_method,
        });
    } catch (error) {
        console.error(error);
    }
};

export const useInitialBillingMutatation = () => {
    const period = useReactiveVar(selectedPeriodVar);
    const params = new URLSearchParams(window.location.search);
    const promocodeParam = params.get('promo_code');
    const hide = params.get('hide') || '';
    const isSinglePayFromUrl = hide.includes('payment_button_recurrent');

    // payment_button_recurrent

    // promo_code=OSN42

    const initailPaymentMethodParam = getInitilaPaymentMethod(period);
    const payment_method = isSinglePayFromUrl ? 'online' : initailPaymentMethodParam;
    // const { type, method } = getPaymentMethodAndType(getInitilaPaymentMethod);


    // console.log(paymentMethodParam, promocodeParam, initilaSubsctiptionType);

    // У нас больше нет триала
    // subscriptionTypeVar(initilaSubsctiptionType);
    //

    // console.log(paymentMethodParam, initilaSubsctiptionType);

    // useEffect(() => {
    //     URLUpdater({ promocode: initialPeriod });
    // }, []);

    const [mutateBilling] = useMutation(ROOT_BILLING_MUTATION, {
        variables: {
            period,
            promocode: promocodeParam,
            payment_method,
        },
        onCompleted: (data) => { onCompletedBillingMutation(data); },
    });
    return mutateBilling;
};

export const useEveryInHiddenPeriod = (period) => {
    const data = useSpecificPeriodData();
    const setName = usePreAssembledBasketType();

    const setsAsEvery = ['every', 'hiddenPremium', 'hiddenTop'];

    return data?.isVisibleInFilter === 'hidden' && setsAsEvery.includes(setName);
};

const BasketResolvingProvider = (props) => {
    const { children, setAppReady, appReady } = props;
    const params = new URLSearchParams(window.location.search);

    const [{ location }] = useRouterState();
    const setName = usePreAssembledBasketType();
    const period = useReactiveVar(selectedPeriodVar);
    const periodData = useSpecificPeriodData();

    // console.log(period);

    /* QUERIES AND MUTATIONS */
    const mutateBilling = useInitialBillingMutatation();

    const [
        addItemsToCartByIdList,
        { loading: isAddItemsToCartByIdListLoading },
    ] = useMutation(ADD_ITEMS_TO_CART_BY_ID_LIST, {
        context: {
            message: 'app:mutate:BasketResolver',
        },
    });
    const [
        addItemsToCartBySchema,
        { loading: isAddItemsToCartBySchemaLoading },
    ] = useMutation(ADD_ITEMS_TO_CART_BY_SCHEMA, {
        context: {
            message: 'app:mutate:BasketResolver',
        },
    });
    const [
        fetchBasket,
        { loading: isFetchBasketLoading },
    ] = useLazyQuery(ROOT_BASKET_QUERY_COPY_RESOLVER, {
        context: {
            message: 'app:query:BasketResolver',
        },
    });
    // const {
    //     data: { user },
    //     loading: isUserLoading,
    // } = useQuery(USER_QUERY, {
    //     context: {
    //         message: 'app:query:BasketResolver',
    //     },
    //     fetchPolicy: 'cache-first',
    // });

    // useEffect(() => {
    //     console.groupCollapsed('GRAND-TODO: Что падает');
    //     console.warn('TODO: Fix: рекусернт в десктопе');
    //     console.groupEnd('такие дела');
    // }, []);


    useEffect(() => {
        if (periodData.isVisibleInFilter === 'visible' && params.has('hide')) {
            // removeFromHideParam('edit_basket');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [period]);

    /* SELECTORS */
    const basketFillingSchema = useMemo(
        () => {
            const categories = parseCategories(location);
            const dishes = parseDishes(location);
            return {
                categories,
                dishes,
            };
        },
        [location],
    );

    const isLoading = useMemo(
        () => (isAddItemsToCartByIdListLoading || isAddItemsToCartBySchemaLoading || isFetchBasketLoading),
        [
            isAddItemsToCartByIdListLoading,
            isAddItemsToCartBySchemaLoading,
            isFetchBasketLoading,
        ],
    );

    /* HANDLERS */
    const handleFillBasket = useCallback(
        async () => {
            const trialScenario = getTrialScenarioFromUrl();
            const { dishes, categories } = basketFillingSchema;

            if (dishes) {
                let dishesToFill = dishes;

                if (params.get('append')) {
                    const { data: existingData } = await fetchBasket({
                        variables: { period },
                        fetchPolicy: 'network-only',
                    });
                    const existingIds = existingData?.cart?.sections
                        ?.flatMap((s) => s.items.map((i) => String(i.dish_id))) ?? [];
                    dishesToFill = [...new Set([...existingIds, ...dishes])];
                }

                await addItemsToCartByIdList({
                    variables: {
                        period,
                        dishes: dishesToFill,
                        trialScenario: getPreAssembledType(window.location.search) === 'top' ? 's_set' : null,
                    },
                    onCompleted: (data) => {
                        isBasketFilledVar(true);
                        setAppReady((state) => ({
                            ...state,
                            BasketResolverProvider: true,
                        }));
                    },
                    update(cache, { data }) {
                        cache.writeQuery({
                            query: ROOT_BASKET_QUERY_COPY_RESOLVER,
                            variables: { period },
                            data: { cart: data.addItemsToCartByIdList.cart },
                        });
                    },

                });
            } else {
                const menuType = parseMenuType(window.location);
                const tags = parseTags(location);
                await addItemsToCartBySchema({
                    variables: {
                        period,
                        menuType,
                        tags: tags || [],
                        schema: categories,
                        trial_scenario: trialScenario,
                    },
                    update(cache, { data }) {
                        cache.writeQuery({
                            query: ROOT_BASKET_QUERY_COPY_RESOLVER,
                            variables: { period },
                            data: { cart: data.addItemsToCartBySchema.cart },
                        });
                    },
                    onCompleted: () => {
                        isBasketFilledVar(true);
                        setAppReady((state) => ({
                            ...state,
                            BasketResolverProvider: true,
                        }));
                        // fetchUpdatedBasket();
                    },
                });
            }
        },
        [
            addItemsToCartByIdList,
            addItemsToCartBySchema,
            fetchBasket,
            location,
            period,
            basketFillingSchema,
            setAppReady,
        ],
    );

    useEffect(
        () => {
            const { dishes, categories } = basketFillingSchema;
            const type = getPreAssembledType(window.location.search);
            const isNeedToFillBasket = type === 'every' || dishes || categories;
            if (isNeedToFillBasket) {
                mutateBilling().then(() => {
                    // console.log(data);
                    handleFillBasket();
                });
            } else {
                isBasketFilledVar(true);
                mutateBilling().then(() => {
                    // console.log(data);

                    fetchBasket({
                        variables: {
                            period,
                            trial_scenario: getTrialScenarioFromUrl(),
                        },
                        fetchPolicy: 'cache-first',
                    }).then(() => {
                        setAppReady((state) => ({
                            ...state,
                            BasketResolverProvider: true,
                        }));
                    });
                });
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    if (!appReady.BasketResolverProvider) {
        return <MenuSkeletonPage />;
    }

    return (
        <BasketResolverContext.Provider value={null}>
            {children}
        </BasketResolverContext.Provider>
    );
};

export default React.memo(BasketResolvingProvider);
